var _excluded = ["className", "defaultOption", "errorText", "hasError", "hasWarning", "warningText", "successText", "helpText", "hidden", "hideRequired", "isInverse", "label", "name", "options", "required", "size", "sort", "onChange", "onBlur", "value", "id", "shape", "isLoading", "aria-label", "disabled", "isBlock", "readOnly", "utils"],
  _excluded2 = ["value", "text"],
  _excluded3 = ["value", "text"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import nodeOfType from '../../utilities/types-of-node';
import Label from './../label';
import Type from './../type';
import Icon from './../icon';
import Hint from '../hint';
import Loader from '../loader';
import map from 'lodash/map';
import omit from 'lodash/omit';
import InverseContext from '../../utilities/inverse-context';
import { StyledCacheWrapper } from '../../styles';
import StyledDropdown from './dropdown.styles';
import StyledDropdownWrapper from './styles/dropdown.wrapper.styles';
import StyledDropdownMenuAffix from './styles/dropdown.menu-affix.styles';
import StyledDropdownIconContainer from './styles/dropdown.icon-container.styles';
import StyledDropdownMenuBackground from './styles/dropdown.menu-background.styles';
import StyledDropdownMenuWrapper from './styles/dropdown.menu-wrapper.styles';
import StyledDropdownMenu from './styles/dropdown.menu.styles';
import StyledDropdownHintWrapper from './styles/dropdown.hint-wrapper.styles';
import withDeprecatedProps from '../../utilities/with-deprecated-props/withDeprecatedProps';
var dropdownPropTypes = {
  /** Adds custom classes to the select container/Dropdown component. */
  className: PropTypes.string,
  /** Sets the default option within the select. */
  defaultOption: PropTypes.object,
  /** Text that should be displayed as the error message. */
  errorText: PropTypes.node,
  /** Boolean value that sets whether there is an error. */
  hasError: PropTypes.bool,
  /** Boolean value that sets whether there is a warning. */
  hasWarning: PropTypes.bool,
  /** Sets the help text of the Dropdown. */
  helpText: PropTypes.node,
  /** Sets the label of the Dropdown. */
  label: PropTypes.oneOfType([PropTypes.string, nodeOfType([Type])]),
  /** Sets the name of the select within the Dropdown. */
  name: PropTypes.string,
  /** Callback function to execute when the value changes. */
  onChange: PropTypes.func,
  /** Callback function to execute when the Dropdown leaves focus. */
  onBlur: PropTypes.func,
  /** Options for selection in the Dropdown. */
  options: PropTypes.array,
  /** Boolean value determining if this field should be filled out as a requirement. */
  required: PropTypes.bool,
  /** Sets the current value of the Dropdown. */
  value: PropTypes.string,
  /** Hides the required. */
  hideRequired: PropTypes.bool,
  /** Sets size of field. */
  size: PropTypes.oneOf(['sm', 'lg']),
  /** Hides field from display if set to true. */
  hidden: PropTypes.bool,
  /** Text which displays on success. */
  successText: PropTypes.node,
  /** Text to display on warning. */
  warningText: PropTypes.node,
  /** Sets the id of the dropdown. */
  id: PropTypes.string,
  /** Component design with dark background. */
  isInverse: PropTypes.oneOf(['auto', true, false]),
  /** Dropdown Shape - pill: fully rounded at each end, square: square corners. */
  shape: PropTypes.oneOf(['pill', 'square']),
  /** Adds a loading underline to the field. This should be used with disabled or readonly. */
  isLoading: PropTypes.bool,
  /** Aria label for dropdown */
  'aria-label': PropTypes.string,
  /**
   * @deprecated since 2.56.0
   * @see aria-label
   */
  ariaLabel: PropTypes.string,
  /** Whether the select dropdown will span the width of the parent. */
  isBlock: PropTypes.bool,
  /** Disable the dropdown */
  disabled: PropTypes.bool,
  /** Read only state of the dropdown, used with defaultOption prop to set an immutable value */
  readOnly: PropTypes.bool,
  /** Add utility props for styling */
  utils: PropTypes.object,
  /** Adds sorting ascending or descending */
  sort: PropTypes.oneOf(['asc', 'desc'])
};
var dropdownDefaultProps = {
  /**
   * Custom classnames placed on the dropdown's container.
   *
   * @property defaultProps.className
   * @type {String}
   * @default ''
   */
  className: '',
  /**
   * An optional default option. Typically
   * viewed as "Select One".
   *
   * @property defaultProps.defaultOption
   * @type {Object}
   * @default null
   */
  defaultOption: null,
  /**
   * Text to display when the dropdown
   * encounters an error or is in its hasError state.
   *
   * @property defaultProps.errorText
   * @type {String}
   * @default ''
   */
  errorText: '',
  /**
   * Toggles the dropdowns hasError state.
   *
   * @property defaultProps.hasError
   * @type {Boolean}
   * @default null
   */
  hasError: null,
  /**
   * Toggles the dropdowns hasWarning state.
   *
   * @property defaultProps.hasWarning
   * @type {Boolean}
   * @default null
   */
  hasWarning: null,
  /**
   * Help text that displays under the
   *
   * @property defaultProps.helpText
   * @type {String}
   * @default ''
   */
  helpText: '',
  /**
   * Sorts dropdown items ascending or descending
   *
   * @property defaultProps.sort
   * @type {String}
   * @default ''
   */
  sort: null,
  /**
   * The dropdown's label.
   *
   * @property defaultProps.label
   * @type {String}
   * @default ''
   */
  label: '',
  /**
   * The dropdown's name attribute value.
   *
   * @property defaultProps.name
   * @type {String}
   * @default ''
   */
  name: '',
  /**
   * onChange callback. Triggers
   * when the value of the dropdown changes
   *
   * @method defaultProps.onChange
   * @param {Event} event - change event
   */
  onChange: function onChange() {},
  onBlur: function onBlur() {},
  /**
   * List of options to render within the select menu.
   *
   * @example
   * [
   *     { text: 'One', value: 'one' },
   *   { text: 'Two', value: 'two' }
   * ]
   *
   * @property defaultProps.options
   * @type {Object[]}
   * @default []
   */
  options: [],
  /**
   * Determines if the dropdown is a required field
   *
   * @property defaultProps.required
   * @type {Boolean}
   * @default false
   */
  required: false,
  /**
   * The dropdown's value. The internal state value
   * will update as this changes.
   *
   * @property defaultProps.value
   * @type {String}
   * @default null
   */
  value: undefined,
  size: null,
  hideRequired: false,
  hidden: null,
  successText: null,
  warningText: null,
  id: null,
  isInverse: 'auto',
  shape: 'square',
  isLoading: false,
  isBlock: true,
  'aria-label': null,
  ariaLabel: null,
  disabled: false,
  readOnly: false,
  utils: {}
};

/**
 * @ignore @description
 * ## Dropdown Component
 * A component that handles options in a dropdown using the select element.
 *
 * @ignore @see Mesh: [Dropdown Docs](https://mesh-component-library.apps.csts-k8cnp-ro-1.r-caas.allstate.com/?path=/story/forms-dropdown--default)
 *
 * @ignore @example
 * ```jsx
 * import { Dropdown } from 'mesh-component-library';
 *
 * <Dropdown {...props} />
 * ```
 */

export var Dropdown = /*#__PURE__*/React.forwardRef(function (props, forwardedRef) {
  var className = props.className,
    defaultOption = props.defaultOption,
    errorText = props.errorText,
    hasError = props.hasError,
    hasWarning = props.hasWarning,
    warningText = props.warningText,
    successText = props.successText,
    helpText = props.helpText,
    hidden = props.hidden,
    hideRequired = props.hideRequired,
    isInverse = props.isInverse,
    label = props.label,
    name = props.name,
    options = props.options,
    required = props.required,
    size = props.size,
    sort = props.sort,
    onChange = props.onChange,
    onBlur = props.onBlur,
    value = props.value,
    id = props.id,
    shape = props.shape,
    isLoading = props.isLoading,
    ariaLabel = props['aria-label'],
    disabled = props.disabled,
    isBlock = props.isBlock,
    readOnly = props.readOnly,
    utils = props.utils,
    other = _objectWithoutProperties(props, _excluded);
  var useIsInverse = React.useContext(InverseContext);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isDropdownEmpty = _useState2[0],
    setIsDropdownEmpty = _useState2[1];
  var _useState3 = useState(value),
    _useState4 = _slicedToArray(_useState3, 2),
    stateVal = _useState4[0],
    setVal = _useState4[1];
  if (isInverse !== 'auto') {
    useIsInverse = isInverse;
  }

  // ensure list of options is an array
  var optionsArray = map(options);
  var handleDropdownValue = function handleDropdownValue() {
    // attempt to find selected option
    var selectedItem = optionsArray.find(function (option) {
      return option.value === stateVal;
    });
    // read text of selected item OR default option OR first option
    setIsDropdownEmpty(function () {
      var _optionsArray$;
      if (selectedItem) {
        return !selectedItem.text;
      }
      return defaultOption ? !(defaultOption !== null && defaultOption !== void 0 && defaultOption.text) : !((_optionsArray$ = optionsArray[0]) !== null && _optionsArray$ !== void 0 && _optionsArray$.text) || false;
    });
  };
  useEffect(function () {
    setVal(value == null ? '' : value);
  }, [value]);
  useEffect(function () {
    handleDropdownValue();
  }, [stateVal]);
  var handleAutoFill = function handleAutoFill(event) {
    if (event.animationName === 'onAutoFillStart') {
      setIsDropdownEmpty(false);
    } else if (event.animationName === 'onAutoFillEnd') {
      handleDropdownValue();
    }
  };
  var handleChange = function handleChange(event) {
    setVal(event.target.value == null ? '' : event.target.value);
    onChange(event);
  };
  var handleBlur = function handleBlur(event) {
    onBlur(event);
  };
  var compareGroups = function compareGroups(a, b, order) {
    var groupA = (a.group || '').toLowerCase();
    var groupB = (b.group || '').toLowerCase();
    if (groupA < groupB) return order === 'asc' ? -1 : 1;
    if (groupA > groupB) return order === 'asc' ? 1 : -1;
    return 0;
  };
  var compareTexts = function compareTexts(a, b, order) {
    if (a.text.toLowerCase() < b.text.toLowerCase()) return order === 'asc' ? -1 : 1;
    if (a.text.toLowerCase() > b.text.toLowerCase()) return order === 'asc' ? 1 : -1;
    return 0;
  };
  var sortByMultipleKeys = function sortByMultipleKeys(a, b, order) {
    var groupComparison = compareGroups(a, b, order);
    if (groupComparison !== 0) return groupComparison;
    return compareTexts(a, b, order);
  };
  var renderOptions = function renderOptions() {
    if (sort == 'asc' || sort == 'desc') {
      optionsArray = optionsArray.sort(function (a, b) {
        return sortByMultipleKeys(a, b, sort);
      });
    }
    var groupedOptions = optionsArray.reduce(function (curr, next) {
      if (next.group) {
        // find index of group in options list
        var groupIndex = curr.findIndex(function (_ref) {
          var optgroup = _ref.optgroup;
          return optgroup && optgroup.name === next.group;
        });
        // create group if doesn't exist
        if (groupIndex === -1) {
          return [].concat(_toConsumableArray(curr), [{
            optgroup: {
              name: next.group,
              options: [next]
            }
          }]);
        }
        curr[groupIndex].optgroup.options.push(next);
        return curr;
      }
      return [].concat(_toConsumableArray(curr), [{
        option: next
      }]);
    }, []);
    return groupedOptions.map(function (_ref2, indexA) {
      var option = _ref2.option,
        optgroup = _ref2.optgroup;
      if (optgroup) {
        return /*#__PURE__*/React.createElement("optgroup", {
          key: "optgroup-".concat(optgroup.name),
          label: optgroup.name
        }, optgroup.options.map(function (groupOption, indexB) {
          return createOption(omit(groupOption, ['group']), indexB);
        }));
      }
      return createOption(option, "option-".concat(indexA));
    });
  };
  var renderHints = function renderHints() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, successText || errorText && hasError || warningText && hasWarning ? null : /*#__PURE__*/React.createElement(React.Fragment, null, helpText && /*#__PURE__*/React.createElement(Hint, {
      id: "".concat(id, "_hint"),
      text: helpText,
      isInverse: useIsInverse
    })), hasError ? /*#__PURE__*/React.createElement(Hint, {
      id: "".concat(id, "_error"),
      text: errorText,
      type: "error",
      isInverse: useIsInverse
    }) : '', hasWarning ? /*#__PURE__*/React.createElement(Hint, {
      type: "warning",
      id: "".concat(id, "_warning"),
      text: warningText,
      isInverse: useIsInverse
    }) : '', successText ? /*#__PURE__*/React.createElement(Hint, {
      type: "success",
      id: "".concat(id, "_success"),
      text: successText,
      isInverse: useIsInverse
    }) : '');
  };
  return /*#__PURE__*/React.createElement(StyledCacheWrapper, null, /*#__PURE__*/React.createElement(StyledDropdownWrapper, {
    hidden: hidden
  }, /*#__PURE__*/React.createElement(StyledDropdown, {
    className: className,
    hasError: hasError,
    hasWarning: hasWarning,
    hasSuccess: successText,
    isBlock: isBlock,
    isDisabled: disabled,
    isDropdownEmpty: isDropdownEmpty,
    isInverse: useIsInverse,
    isLoading: isLoading,
    isReadOnly: readOnly,
    isRequired: required,
    label: label,
    shape: shape,
    size: size,
    sort: sort,
    utils: utils
  }, /*#__PURE__*/React.createElement("span", {
    htmlFor: id
  }, /*#__PURE__*/React.createElement(Label, {
    htmlFor: id,
    text: label,
    required: required,
    hideRequired: hideRequired,
    isInverse: useIsInverse
  })), /*#__PURE__*/React.createElement(StyledDropdownMenuAffix, null, /*#__PURE__*/React.createElement(StyledDropdownMenuWrapper, null, isLoading && /*#__PURE__*/React.createElement(Loader, null), /*#__PURE__*/React.createElement(StyledDropdownMenu, _extends({
    as: setElementType(readOnly)
  }, other, {
    id: id,
    name: name,
    onAnimationStart: handleAutoFill,
    onChange: handleChange,
    onBlur: handleBlur,
    required: required,
    hasError: hasError,
    disabled: disabled,
    readOnly: readOnly,
    hasWarning: hasWarning,
    hasSuccess: successText,
    "aria-label": ariaLabel,
    "aria-describedby": "".concat(id, "_error ").concat(id, "_hint"),
    value: renderOptionValue(stateVal, defaultOption),
    ref: forwardedRef
  }), renderOptionsText(readOnly, defaultOption, renderOptions)), /*#__PURE__*/React.createElement(StyledDropdownMenuBackground, null, /*#__PURE__*/React.createElement(StyledDropdownIconContainer, {
    "aria-hidden": true
  }, /*#__PURE__*/React.createElement(Icon, {
    rotation: 270,
    icon: "chevron",
    color: "blue-dark",
    alt: "Down arrow"
  })))))), /*#__PURE__*/React.createElement(StyledDropdownHintWrapper, null, renderHints())));
});
Dropdown.defaultProps = dropdownDefaultProps;
Dropdown.displayName = 'Dropdown';
Dropdown.propTypes = dropdownPropTypes;
/**
 * @type React.FC<dropdownPropTypes>
 */
export default withDeprecatedProps(Dropdown);

/**
 * Returns an HTML option element
 * filled in with the provided properties.
 *
 * @method createDefaultOption
 * @param {Object} option
 * @param {String} [option.text='']
 * @param {String} [option.value='']
 * @returns {HTMLOptionElement} an HTML option element
 */
export var createDefaultOption = function createDefaultOption(options) {
  var _options$value = options.value,
    value = _options$value === void 0 ? '' : _options$value,
    _options$text = options.text,
    text = _options$text === void 0 ? '' : _options$text,
    other = _objectWithoutProperties(options, _excluded2);
  return /*#__PURE__*/React.createElement("option", _extends({}, other, {
    value: value
  }), text);
};

/**
 * Returns an HTML option element
 * filled in with the provided properties.
 * Since this is used in a loop, this method
 * also applies a key to the returned option.
 *
 * @method createDefaultOption
 * @param {Object} option
 * @param {String} [option.text='']
 * @param {String} [option.value='']
 * @param {String} key
 * @returns {HTMLOptionElement} an HTML option element
 */
export var createOption = function createOption(options, key) {
  var _options$value2 = options.value,
    value = _options$value2 === void 0 ? '' : _options$value2,
    _options$text2 = options.text,
    text = _options$text2 === void 0 ? '' : _options$text2,
    other = _objectWithoutProperties(options, _excluded3);
  return /*#__PURE__*/React.createElement("option", _extends({}, other, {
    key: key,
    value: value == null ? '' : value
  }), text);
};

/** Sets the element type to input when readOnly */
var setElementType = function setElementType(isReadOnly) {
  return isReadOnly ? 'input' : 'select';
};

/**  Returns options text when element type is select */
var renderOptionsText = function renderOptionsText(readOnly, defaultOption, renderOptions) {
  if (!readOnly) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, defaultOption ? createDefaultOption(defaultOption) : '', renderOptions());
  }
};

/** Sets the value in dropdown option */
var renderOptionValue = function renderOptionValue(stateVal, defaultOption) {
  if (stateVal) {
    return stateVal;
  }
  if (defaultOption) {
    return defaultOption.value;
  }
  return '';
};